<template>
  <div class="bg-danger-light border border-danger-dark rounded text-danger-dark text-left p-4">
    <slot>
      <p class="font-bold mb-2">
        <slot name="title"> Payment method failed to load. </slot>
      </p>
      <p class="text-sm">
        <slot name="description">
          This is usually caused by an Ad Blocker. Please refresh to try again. If the problem continues please call
          customer service at <UniversalLink link="PHONE">{{ $sitewideConfig.config.phoneGeneral }}</UniversalLink> to
          place your order.
        </slot>
      </p>
    </slot>
  </div>
</template>
